import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Heading } from '@fiverr-private/typography';
import { TruncatedText } from '../TruncatedText';
import type { SellerBriefResponse } from '../../../types/SellerBriefResponse';

interface GeneratedContentProps {
  generatedContent: SellerBriefResponse['content']['generatedContent'];
}

export const GeneratedContent: React.FC<GeneratedContentProps> = ({ generatedContent }) => (
  <>
    {generatedContent?.map(({ title, content }) => (
      <Stack key={title} direction="column" gap="1">
        <Heading size="h_xxs">{title}</Heading>
        <TruncatedText text={content} linesToTruncate="FIVE" />
      </Stack>
    ))}
  </>
);
